import AnalyticsIcons from '@/icons/AnalyticsIcons'
import CustomerMktIcons from '@/icons/CustomerMktIcons'
import PeopleIcons from '@/icons/PeopleIcons'
import { useTranslation } from 'react-i18next'
import AllLeadsList from './AllLeadsList'
import MyLeadsList from './MyLeadsList'
import StatisticalTab from './StatisticalTab'

export const useTabs = () => {
    const { t } = useTranslation()

    return [
        {
            label: t('all-leads'),
            value: 'all',
            startIcon: <CustomerMktIcons className="w-4 h-4" />,
            component: <AllLeadsList />,
        },
        {
            label: t('my-leads'),
            value: 'my-leads',
            startIcon: <PeopleIcons className="w-4 h-4" />,
            component: <MyLeadsList />,
        },
        {
            label: t('statistical'),
            value: 'statistical',
            startIcon: <AnalyticsIcons className="w-4 h-4" />,
            component: <StatisticalTab />,
        },
    ]
}
